import React from "react";
import { IFilterLabels } from "./iFilterLabels";

const FilterLabels: React.FC<IFilterLabels> = ({
  LabelText,
  closeBtn,
  FilterAction,
}) => {
  return (
    <div className="ed-filter-label-wrapper">
      {closeBtn ? (
        <>
          <div className="tag-container">
            <div className="ed-filter-label-text">{LabelText}</div>
            <span
              className="edel-icon-close hand_cursor"
              onClick={() => FilterAction(LabelText)}
            ></span>
          </div>
        </>
      ) : (
        <div className="tag-container clear-all-fix">
          <div
            className="ed-filter-label-text"
            onClick={() => FilterAction(LabelText)}
          >
            {LabelText}
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterLabels;
